export const AI_TYPING_DELAY_MIN_MS = 60000;
export const AI_TYPING_DELAY_MAX_MS = 120000;

export function getRandomAiTypingDelay() {
  return (
    Math.floor(
      Math.random() *
        (AI_TYPING_DELAY_MAX_MS - AI_TYPING_DELAY_MIN_MS + 1)
    ) + AI_TYPING_DELAY_MIN_MS
  );
}
